import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var phoneRegex = /^1\d{10}$/;
export default {
  name: 'smartControlRule_page',
  props: {
    current: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      pageConfig: {
        editPageName: '规则',
        addFunName: 'smartControlRuleAdd',
        modifyFunName: 'smartControlRuleModify',
        delFunName: 'smartControlRuleDel',
        queryFunName: 'smartControlRuleQuery',
        detailFunName: 'smartControlRuleDetail',
        queryUserFunName: 'userQuery'
      },
      searchForm: {
        page: 1,
        limit: 10,
        sortField: 'item_code,warn_level'
      },
      formData: {
        smartControlId: this.current.id,
        labId: this.current.labId,
        warnCategory: 'Threshold',
        warnType: 'Lower_Limit',
        warnFrequency: 'Interval_Time',
        warnLevel: 'Seriousness',
        enabledState: true
      },
      rules: {
        warnLower: [{
          required: true,
          message: '请输入触发下限',
          trigger: 'blur'
        }],
        itemCode: [{
          required: true,
          message: '请选择告警参数',
          trigger: 'blur'
        }],
        receiverUserFirst: [{
          pattern: /^1\d{10}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        receiverUserSecond: [{
          pattern: /^1\d{10}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '120px',
      emptyFormData: {},
      userList: [],
      userForm: {
        page: 1,
        limit: 10
      },
      msgReceiverUser: [],
      setSelectPage: {
        pageSize: 10,
        currentPage: 1,
        pagerCount: 5,
        total: 0
      },
      loading: false,
      smartControlItem_show: false,
      deviceItem_show: false,
      device_show: false,
      askCmd_show: false,
      user_show: false
    };
  },
  components: {
    smartControlItemSel: function smartControlItemSel() {
      return import('./smartControlItem_sel.vue');
    },
    deviceSel: function deviceSel() {
      return import('../device_sel');
    },
    deviceAskCmdSel: function deviceAskCmdSel() {
      return import('../device_askCmd_sel.vue');
    },
    userSel: function userSel() {
      return import('../../user/user_sel.vue');
    }
  },
  mounted: function mounted() {
    console.log('smartControlRule_page mounted');
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  watch: {
    editDialogShow: function editDialogShow(to) {
      if (to) {
        this.setSelectPage.currentPage = 1;
        this.userQuery();
      }
    },
    msgReceiverUser: function msgReceiverUser(to) {
      console.log('msgReceiverUser', to);
    },
    'formData.warnCategory': {
      handler: function handler(to) {
        if (to == 'Offline') {
          this.$set(this.formData, 'warnType', 'Upper_Limit');
        }
      },
      deep: true
    },
    'formData.warnType': {
      handler: function handler(to) {
        this.$set(this.rules, 'warnLower', null);
        this.$refs['formDataVerify'].clearValidate();
        if (to == 'Lower_Limit') {
          this.$set(this.rules, 'warnLower', [{
            required: true,
            message: '请输入触发下限',
            trigger: 'change'
          }]);
        } else if (to == 'Upper_Limit') {
          this.$set(this.rules, 'warnUpper', [{
            required: true,
            message: '请输入触发上限',
            trigger: 'change'
          }]);
        } else if (to == 'Between') {
          this.$set(this.rules, 'warnUpper', [{
            required: true,
            message: '请输入触发上限',
            trigger: 'change'
          }]);
          this.$set(this.rules, 'warnLower', [{
            required: true,
            message: '请输入触发下限',
            trigger: 'change'
          }]);
        } else if (to == 'Equals' || to == 'Not_Equals') {
          this.$set(this.rules, 'warnValue', [{
            required: true,
            message: '请输入触发值',
            trigger: 'change'
          }]);
        }
      },
      deep: true
    },
    'formData.warnFrequency': {
      handler: function handler(to) {
        this.$set(this.rules, 'warnInterval', null);
        this.$refs['formDataVerify'].clearValidate();
        if (to == 'Interval_Time') {
          this.$set(this.rules, 'warnInterval', [{
            required: true,
            message: '请输入预警间隔',
            trigger: 'change'
          }]);
        }
      },
      deep: true
    }
  },
  methods: {
    back: function back() {
      this.$emit('child-go-smartControl');
    },
    smartControlItemSel: function smartControlItemSel(data) {
      if (data) {
        this.$set(this.formData, 'itemName', data.typeName);
        this.$set(this.formData, 'itemCode', data.typeCode);
      }
      this.smartControlItem_show = false;
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.msgReceiverUserList = [];
      this.formData = paramData;
      if (!this.formData.warnCategory) {
        this.formData.warnCategory = 'Threshold';
      }
      if (!this.formData.warnType) {
        this.formData.warnType = 'Lower_Limit';
      }
      if (!this.formData.warnFrequency) {
        this.formData.warnFrequency = 'Interval_Time';
      }
      if (!this.formData.warnLevel) {
        this.formData.warnLevel = 'Seriousness';
      }
      if (this.formData.msgReceiverUser) {
        this.msgReceiverUser = this.formData.msgReceiverUser.split(',');
        for (var index in this.msgReceiverUser) {
          this.msgReceiverUserList.push({
            id: this.msgReceiverUser[index],
            nickname: this.formData.msgReceiverUserNicknames.split(',')[index]
          });
        }
      } else {
        this.msgReceiverUser = [];
      }
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
      this.formData.upperCode = this.searchForm.upperCode;
    },
    edit: function edit(data) {
      this.initFormData(data);
      this.editDialogTitle = this.pageConfig.editPageName + '维护';
      this.editDialogShow = true;
      // this.$api[this.pageConfig.detailFunName](data.id).then((res) => {
      //   this.initFormData({...res.data, itemName:data.itemName})

      //   this.editDialogTitle = this.pageConfig.editPageName + '维护'
      //   this.editDialogShow = true
      // })
    } // 选择设备
    ,
    deviceSel: function deviceSel(data) {
      if (data) {
        this.$set(this.formData, 'controlDeviceName', data.deviceName);
        this.$set(this.formData, 'controlDeviceId', data.id);
      }
      this.device_show = false;
    } // 选择设备命令
    ,
    askCmdClick: function askCmdClick() {
      if (!this.formData.controlDeviceId) {
        this.$message.info('请先选择控制设备！');
        return;
      }
      this.askCmd_show = true;
    },
    askCmdSel: function askCmdSel(val) {
      if (val) {
        this.$set(this.formData, 'controlDeviceAskcmdName', val.name);
        this.$set(this.formData, 'controlDeviceOperateId', val.id);
      }
      this.askCmd_show = false;
    } // 选择消息接收人
    ,
    userClick: function userClick(val) {
      this.userIdx = val;
      this.user_show = true;
    },
    userSel: function userSel(val) {
      if (val) {
        if (this.userIdx == 1) {
          this.$set(this.formData, 'receiverUserFirstNickname', val.nickname);
          this.$set(this.formData, 'receiverUserFirst', val.id);
        } else if (this.userIdx == 2) {
          this.$set(this.formData, 'receiverUserSecondNickname', val.nickname);
          this.$set(this.formData, 'receiverUserSecond', val.id);
        }
      }
      this.user_show = false;
    },
    del: function del(id) {
      var _this = this;
      this.$confirm('确定要删除吗').then(function () {
        _this.$api[_this.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this.$message.success('删除成功');
            _this.query();
          } else {
            _this.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this2 = this;
      this.queryLoading = true;
      this.searchForm.smartControlId = this.current.id;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this2.tableData = res.data || [];
        _this2.totalCount = res.count;
        _this2.queryLoading = false;
      });
    },
    userQuery: function userQuery() {
      var _this3 = this;
      this.$api[this.pageConfig.queryUserFunName]({
        page: this.setSelectPage.currentPage,
        limit: this.setSelectPage.pageSize
      }).then(function (res) {
        if (_this3.msgReceiverUserList && _this3.msgReceiverUserList.length) {
          var _iterator = _createForOfIteratorHelper(_this3.msgReceiverUserList),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              var flag = true;
              var _iterator2 = _createForOfIteratorHelper(res.data),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var opt = _step2.value;
                  if (item.id == opt.id) {
                    flag = false;
                    break;
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              if (flag) {
                res.data.push(item);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        _this3.userList = res.data || [];
        _this3.setSelectPage.total = res.count;
      });
    },
    userPageChange: function userPageChange(page) {
      this.setSelectPage.currentPage = page;
      this.userQuery();
    },
    submitFormData: function submitFormData() {
      var _this4 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          _this4.formData.smartControlId = _this4.current.id;
          if (_this4.formData.id) {
            _this4.$api[_this4.pageConfig.modifyFunName](_this4.saveFormDataProcess(_objectSpread(_objectSpread({}, _this4.formData), {}, {
              msgReceiverUser: _this4.msgReceiverUser.toString()
            }))).then(function (res) {
              if (res.data) {
                _this4.$message.success('编辑成功');
                _this4.initFormData(_this4.emptyFormData);
                _this4.editDialogShow = false;
                _this4.query();
              } else {
                _this4.$message.error('编辑失败');
              }
            });
          } else {
            _this4.$api[_this4.pageConfig.addFunName](_this4.saveFormDataProcess(_objectSpread(_objectSpread({}, _this4.formData), {}, {
              msgReceiverUser: _this4.msgReceiverUser.toString()
            }))).then(function (res) {
              if (res.data) {
                _this4.$message.success('新增成功');
                _this4.initFormData(_this4.emptyFormData);
                _this4.editDialogShow = false;
                _this4.query();
              } else {
                _this4.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'item_code,warn_level';
      this.query();
    }
  }
};